import { render } from "./KidsSite.vue?vue&type=template&id=9ee936a8"
import script from "./KidsSite.vue?vue&type=script&lang=js"
export * from "./KidsSite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__